<template lang="pug">
section
  .blocks.two-cols
    .block(:class="{'opened': content.opened}")
      h3(@click="content.opened = !content.opened") {{ content.title }}
      .block-content {{ content.content }}

    .block(:class="{'opened': services.opened}")
      h3(@click="services.opened = !services.opened") {{ services.title }}
      .block-content
        ul.list
          li(v-for="s of services.content")
            span {{s}}

</template>

<script>
import '@/contents/oFirmie'
import {Content, Services} from '../contents/oFirmie';

export default {
  name: "AboutUs",
  data() {
    return {
      content: {},
      services: {}
    }
  },
  mounted() {
    this.content = Content
    this.services = Services
  }
}
</script>

<style scoped>

</style>
